import React from 'react';
import assets from '../../../../../util/assets';
import PropTypes from "prop-types";

const DropdownItem = (props) => {

    if (props.isFetching) {
        return (
            <div className="my-library-actions" style={{justifyContent:'center'}}>
                <img className="my-library-actions-img"
                     src={assets.loading_blue}/>
            </div>
        )
    }
    return (
        <div className="my-library-actions" onClick={props.onClick}>
            <div><img className="my-library-actions-img" src={props.icon}/></div>
            <div className="my-library-actions-title">{props.text}</div>
        </div>
    );
}


DropdownItem.propTypes = {
    isFetching: PropTypes.bool,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    text: PropTypes.string,
};

// Specifies the default values for props:
DropdownItem.defaultProps = {
    isFetching: false,
    onClick: () => {
        //console.log("Clicked")
    },
    icon: assets.clipstore.more.publishVideo,
    text: "Text"
};

export default DropdownItem;